import './App.css'
import Header from './components/Header'
import MainContainer from './components/MainContainer'
import SessionsList from './components/SessionsList'
import CreateEditSession from './pages/CreateEditSession'
import SessionDetailsPage from './pages/SessionDetailsPage'
import { Routes, Route, BrowserRouter } from 'react-router-dom'
import HomePage from './pages/HomePage'
import LoginPage from './pages/LoginPage'
import RequireAuth from './components/require-auth/RequireAuth'
import RequireGuest from './components/require-guest/RequireGuest'
import InitializeAuth from './components/initialize-auth/InitializeAuth'
import AuthorizeRedirectPage from './pages/AuthorizeRedirectPage'
import { ROUTES } from './routes'
import EmailConfirmationPage from './pages/EmailConfirmationPage'
import EmailConfirmedPage from './pages/EmailConfirmedPage'
import ResetPasswordPage from './pages/ResetPasswordPage'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { useState, useEffect } from 'react'
import ResetPasswordEmailSentPage from './pages/ResetPasswordEmailSentPage'
import TermsOfServicePage from './pages/TermsOfServicePage'
import PrivacyPolicyPage from './pages/PrivacyPolicyPage'
import SettingsPage from './pages/SettingsPage'

function App() {
  const [isDarkMode, setIsDarkMode] = useState(false);

  // Check for dark mode
  useEffect(() => {
    // Listen for theme changes
    const observer = new MutationObserver(() => {
      setIsDarkMode(document.documentElement.classList.contains('dark'));
    });
    
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class']
    });

    return () => observer.disconnect();
  }, []);

  return (
    <InitializeAuth>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        {/* Header  */}
        <Header />
        <MainContainer>
          <Routes>
            <Route path={ROUTES.SESSIONS} element={
              <RequireAuth>
                <SessionsList />
              </RequireAuth>} />
            <Route path={ROUTES.SESSION_DETAILS} element={
              <RequireAuth>
                <SessionDetailsPage />
              </RequireAuth>} />
            <Route path={ROUTES.CREATE_SESSION} element={
              <RequireAuth>
                <CreateEditSession />
              </RequireAuth>} />
            <Route path={ROUTES.EDIT_SESSION} element={
              <RequireAuth>
                <CreateEditSession />
              </RequireAuth>} />
            <Route path={ROUTES.HOME} element={
              <RequireAuth>
                <HomePage />
              </RequireAuth>} />
            <Route path={ROUTES.HOME_PAGE} element={
              <RequireAuth>
                <HomePage />
              </RequireAuth>} />
            <Route path={ROUTES.LOGIN} element={
              <RequireGuest>
                <LoginPage />
              </RequireGuest>
            } />
            <Route
              path={ROUTES.AUTHORIZE_REDIRECT}
              element={<AuthorizeRedirectPage />}
            />
            <Route
              path={ROUTES.EMAIL_CONFIRMATION}
              element={
                <RequireGuest>
                  <EmailConfirmationPage />
                </RequireGuest>
              }
            />
            <Route
              path={ROUTES.EMAIL_CONFIRMED}
              element={
                <RequireGuest>
                  <EmailConfirmedPage />
                </RequireGuest>
              }
            />
            <Route
              path={ROUTES.RESET_PASSWORD}
              element={
                <RequireGuest>
                  <ResetPasswordPage />
                </RequireGuest>
              }
            />
            <Route
              path={ROUTES.RESET_PASSWORD_EMAIL_SENT}
              element={
                <RequireGuest>
                  <ResetPasswordEmailSentPage />
                </RequireGuest>
              }
            />
            <Route
              path={ROUTES.SETTINGS}
              element={
                <RequireAuth>
                  <SettingsPage />
                </RequireAuth>
              }
            />
            <Route
              path={ROUTES.TERMS_OF_SERVICE}
              element={<TermsOfServicePage />}
            />
            <Route
              path={ROUTES.PRIVACY_POLICY}
              element={<PrivacyPolicyPage />}
            />
          </Routes>

        </MainContainer>

        {/* Toast Notifications */}
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme={isDarkMode ? "dark" : "light"}
        />
      </BrowserRouter>
    </InitializeAuth>

  )
}

export default App
